import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getCountriesAndCitiesApi } from './getCountriesAndCities.api'
import getCountriesAndCitiesInitialState from './getCountriesAndCities.initialState'
import { GetCountriesAndCitiesErrorResponse, GetCountriesAndCitiesRequestPayload } from './getCountriesAndCities.types'

export const getCountriesAndCities = createAsyncThunk(
  urls.flights.getCountriesAndCities,
  async (payload: GetCountriesAndCitiesRequestPayload, { rejectWithValue }) => {
    const { onSuccess } = payload

    try {
      const response = await getCountriesAndCitiesApi()

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getCountriesAndCitiesSlice = createSlice({
  name: urls.flights.getCountriesAndCities,
  initialState: getCountriesAndCitiesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountriesAndCities.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getCountriesAndCities.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getCountriesAndCities.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetCountriesAndCitiesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getCountriesAndCitiesActions, reducer: getCountriesAndCitiesReducer } =
  getCountriesAndCitiesSlice
export default getCountriesAndCitiesSlice.reducer
